module.exports = __webpack_public_path__ + "media/images/sp/plans/inclusion_25-50edb2211d0613b52a9d1c3b1105730e.png";